import { RouterView } from 'vue-router'
import { getAbsoluteBackendURL } from '@/utils/backend'
import i18n from '@/i18n/i18n'

export const SETTINGS_FINANCIAL_ROUTE = 'financial'
export const SETTINGS_FINANCIAL_INVOICES_ROUTE = 'financial.invoicing.list'
export const SETTINGS_FINANCIAL_INVOICE_DETAILS_ROUTE = 'financial.invoicing.detail'
export const SETTINGS_FINANCIAL_INVOICES_HISTORY_ROUTE = 'financial.invoicing.history'
export const SETTINGS_FINANCIAL_PAYMENTS_ROUTE = 'financial.payments.recurringcontract'
export const SETTINGS_FINANCIAL_TRANSACTIONS_ROUTE = 'financial.transactions.list'
export const SETTINGS_FINANCIAL_INVOICE_PAY_ROUTE = 'financial.invoicing.pay'

export default {
  name: SETTINGS_FINANCIAL_ROUTE,
  path: 'financial',
  redirect: { name: SETTINGS_FINANCIAL_INVOICES_ROUTE },
  component: () => import('@/app/settings/financial/views/FinancesNav.vue'),
  children: [
    {
      name: SETTINGS_FINANCIAL_INVOICES_ROUTE,
      path: 'invoices/list',
      component: () => import('@/app/settings/financial/views/InvoiceList.vue'),
      meta: {
        pageTitle: () => i18n.t('Financial'),
        permissions: ['manage_invoices'],
      },
    },
    {
      name: SETTINGS_FINANCIAL_INVOICE_DETAILS_ROUTE,
      path: 'invoices/:invoiceRef/details',
      component: () => import('@/app/settings/financial/views/InvoiceDetailView.vue'),
      props: route => ({
        invoiceRef: route.params.invoiceRef,
      }),
      meta: {
        pageTitle: () => i18n.t('Financial'),
        permissions: ['manage_invoices'],
      },
    },
    {
      name: SETTINGS_FINANCIAL_INVOICES_HISTORY_ROUTE,
      path: 'invoices/:invoiceRef/history',
      component: () => import('@/app/settings/financial/views/InvoiceHistory.vue'),
      props: route => ({
        invoiceRef: route.params.invoiceRef,
      }),
      meta: {
        pageTitle: () => i18n.t('Financial'),
        permissions: ['manage_invoices'],
      },
    },
    {
      name: SETTINGS_FINANCIAL_INVOICE_PAY_ROUTE,
      path: 'invoices/:invoiceRef/pay',
      component: RouterView,
      beforeEnter: redirectToPayment,
      meta: {
        pageTitle: () => '',
        permissions: ['manage_invoices'],
      },
    },
    {
      name: SETTINGS_FINANCIAL_PAYMENTS_ROUTE,
      path: 'payments/direct-debit',
      component: () => import('@/app/settings/financial/views/RecurringContractView.vue'),
      meta: {
        pageTitle: () => i18n.t('Financial'),
        permissions: ['manage_invoices'],
      },
    },
    {
      name: SETTINGS_FINANCIAL_TRANSACTIONS_ROUTE,
      path: 'transactions/list',
      component: () => import('@/app/settings/financial/views/TransactionList.vue'),
      meta: {
        pageTitle: () => i18n.t('Financial'),
        permissions: ['manage_invoices'],
      },
    },
  ],
}

function redirectToPayment(to) {
  const promise = Promise.resolve()
  const { params, query } = to

  let url = getAbsoluteBackendURL(
    `/payments/initiate/?item_id=${params.invoiceRef}&item_content_type=invoicing.invoice`,
  )

  if (query.return_url) {
    url += '&return_url=' + encodeURIComponent(query.return_url)
  }

  if (query.recurring) {
    url += '&recurring=' + encodeURIComponent(query.recurring)
  }

  // The redirect here does not work in Safari 13.1 and above, unless we force a temporary pause before changing the
  // URL. See https://sendcloud.atlassian.net/browse/SC-28761
  setTimeout(() => {
    window.location.href = url
  }, 1000)

  // ... we intentionally don't keep our promise,
  // the redirect will take over
  return promise
}
